import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgFill = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 25,
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("rect", {
		x: 22.4375,
		y: 10.2168,
		width: 4,
		height: 20,
		transform: "rotate(90 22.4375 10.2168)",
		fill: "#395566"
	})
});
export default SvgFill;
